export const ModelByoUrl = (modelName: string): string => {
  // once X15 can reference the configure page by model, put this code back up
  // const base: string = "/build-your-own/build/variants/";
  // modelName = modelName.toLowerCase();

  // if (modelName === "wrx-and-wrx-sti" || modelName === "wrx-or-wrx-sti") {
  //   return base;
  // } else if(modelName === "xv-hybrid" || modelName === "xv hybrid"){
  //   return `${base}?model=xv`;
  // }else if(modelName === "forester-hybrid" || modelName === "forester hybrid"){
  //   return `${base}?model=forester`;
  // } else{
  //   return `${base}?model=${modelName}`;
  // }

  // interim, all models send to one and only configure page
  return "configure/";
};

export const ModelPageUrl = (modelName: string): string => {
  const base: string = "/";
  modelName = modelName.toLowerCase();

  if (modelName === "wrx" || modelName === "wrx-sti" || modelName === "wrx sti") {
    return `${base}wrx-and-wrx-sti`;
  }

  //Handling the hybrid variants. All hybrids has its own model page.
  if (modelName.endsWith("hybrid")) {
    return `${base}hybrid`;
  }

  return `${base}${modelName}`;
};
